import * as React from 'react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router-dom';
import patchData from 'Utils/PatchData';
import postData from 'Utils/PostData';
import deleteData from 'Utils/DeleteData';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


//Components
import GenericForm from './GenericForm';
import AddElementForm from 'Screens/Concept/Instructor/Components/AddElementForm';

//Assets
import '../Assets/toggleSwitch.sass';

import { Card, Accordion, Row, Col, Button, Modal, DropdownButton, Dropdown, Container, ToggleButton, AccordionCollapse, AccordionToggle } from 'react-bootstrap';
import { FaEdit, FaFolder } from 'react-icons/fa';
import { MdDelete, MdImportExport } from 'react-icons/md';
import { FiPlusCircle } from 'react-icons/fi';
import { FcCamcorderPro, FcDocument, FcFolder, FcQuestions, FcVideoFile } from "react-icons/fc";
import { GrDrag } from "react-icons/gr";
import { BsFillCaretDownFill } from "react-icons/bs";
import { BsFillCaretUpFill } from "react-icons/bs";
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';

// dragula for reordering
import * as dragula from 'dragula';
import 'dragula/dist/dragula.css';


//interfaces
import { IGroupConcept, ICourseGC } from 'store/StateInterfaces';

// actions
import {
    loadGroupConceptsRequest,
    deleteGroupConceptsRequest,
    publishGroupConceptsRequest,
    reorderGroupConceptsRequest,
    addGroupConceptsRequest
} from '../Actions/Actions';
import { AccordionActions, AccordionDetails, Collapse } from '@material-ui/core';



interface IProps {
    loaded: boolean;
    concepts: Array<IGroupConcept>;
    deleteCallBack: any;
    editCallBack: any;
    group: any;
    index: any;
    orderParent: boolean;
    orderChild: boolean;
    actions: any;
}
interface IState {
    order: boolean;
    add: boolean;
    edit: boolean;
    type: string;
    open: any;
    prevopen:any;
}


class Group extends React.Component<IProps, IState> {

    private dragulaService: any;
    private conceptsCopy: any;
    private idToConcept: any;

    constructor(props: IProps) {
        super(props);
        this.state = {
            order: false,
            add: false,
            edit: false,
            type: undefined,
            open: false,
            prevopen:false

            
        };
    }

    @autobind
    public handleEdit(event) {


        event.stopPropagation();
        this.setState({
            edit: true
        })
    }

    @autobind
    public saveEdit(data: FormData) {
        this.props.editCallBack(this.props.group.id, data)
            .then(res => {
                this.setState({ edit: false });
            });
    }

    @autobind
    public cancelEdit(event) {
        this.setState({
            edit: false
        })
    }

    @autobind
    public deleteGroup(event) {
        event.stopPropagation();
        this.props.deleteCallBack(this.props.group.id);
    }

    componentDidMount() {
        if (!this.props.loaded) {
            this.props.actions.loadGroupConceptsRequest(this.props.group.id);
        }
       
            this.setState({
            open: this.props.index == 0,
            prevopen:this.props.index == 0
        })
        
    }

    @autobind
    public handleAddConcept(type, data) {
        let sectionData = undefined;
        let elemData = undefined;
        if (type === 'section') {
            sectionData = data;
        }
        else {
            elemData = data
            sectionData = new FormData();
            sectionData.append('title', data.get('title'));
            sectionData.append('description', data.get('description'));
        }
        this.props.actions.addGroupConceptsRequest(this.props.group.id, type, sectionData, elemData);
        this.setState({
            type: undefined,
            add: false
        })
    }

    @autobind
    public openModal(eventKey, event) {
        console.log(eventKey);

        this.setState({
            add: true,
            type: eventKey
        })
    }

    @autobind
    public closeModal() {
        this.setState({
            add: false
        })
    }

    @autobind
    public publishAll(e) {
        e.stopPropagation();

        // publish all unpublished concept
        const conceptToPublish = this.props.concepts.filter(concept => !concept.is_published);
        conceptToPublish.forEach(concept => {
            this.handlePublishConcept(concept);
        })
    }

    @autobind
    public handlePublishConcept(concept) {
        this.props.actions.publishGroupConceptsRequest(this.props.group.id, concept.id)
    }

    @autobind
    public handleDeleteConcept(conceptid) {
        if (confirm('Are you sure ?'))
            this.props.actions.deleteGroupConceptsRequest(this.props.group.id, conceptid)
    }

    @autobind
    public saveOrder() {

        const playlist = this.conceptsCopy.map(c => c.id);
        const formData = new FormData();
        formData.append('playlist', JSON.stringify(playlist));
        this.props.actions.reorderGroupConceptsRequest(this.props.group.id, formData, this.conceptsCopy)
            .catch(err => {
                this.props.actions.loadGroupConceptsRequest(this.props.group.id)
            })
            .then(res => {
                this.setState({ order: false })
            })

    }
    @autobind
    public handleToggle(event) {

        this.setState(
            (state) => ({
                prevopen : this.state.open,
                open : !this.state.open
            })
        );
        console.log(this.state.open)

    }
    // @autobind
    // public handleReorder() {
    //     if (!this.state.order) {
    //         this.conceptsCopy = [...this.props.concepts];
    //         this.idToConcept = {};
    //         this.props.concepts.map((c) => {
    //             this.idToConcept[c.id] = c;
    //         });

    //         this.dragulaService = dragula([document.getElementById(`conceptListContainer-${this.props.group.id}`)], {
    //             revertOnSpill: true,
    //             moves: function (el, container, handle) {
    //                 console.log(handle);
    //                 return handle.classList.contains(`conceptListHandle`);
    //             }
    //         }).on('drop', function (el, container, handle) {
    //             console.log('element', el);
    //             console.log('container', container);
    //             console.log('handle', handle);
    //             this.conceptsCopy = Array.from(container.children).map(function (c) {
    //                 return this.idToConcept[c["id"]]
    //             }.bind(this))
    //         }.bind(this));

    //         this.setState({
    //             order: true
    //         });
    //     }
    //     else {
    //         this.dragulaService.destroy();
    //         this.saveOrder();
    //     }
    // }

    public render() {
        if (this.state.edit) {
            return <GenericForm
                heading="Edit Chapter"
                title={this.props.group.title}
                description={this.props.group.description}
                saveCallBack={this.saveEdit}
                closeCallBack={this.cancelEdit}
            />;

        }
        return (

            <Card id={this.props.group.id} >

        <Accordion.Toggle as={Card.Header} eventKey={this.props.orderParent ? '-1' : `${this.props.index}`} onClick={this.handleToggle} >
                    <Row>
                        <Col md={{ span: 8 }}>
                            <h5 className="groupListHandle">
                                {this.props.orderParent ? <GrDrag size={20} className="groupListHandle" color="#ccc" /> : ''}{this.props.group.title}
                            </h5>
                        </Col>
                        <Col md={{ span: 4 }} className="text-right">
                            <Button className="btn btn-sm mx-2 shadow" onClick={this.publishAll}
                                style={{ backgroundColor: "darkcyan" }}
                            >
                                Publish All
                            </Button>
                            <Button className="btn btn-sm" variant="light"
                                onClick={this.handleEdit} >
                                <FaEdit size={18} />
                            </Button>
                            <Button className="btn btn-sm" variant="light"
                                onClick={this.deleteGroup}
                            >
                                <MdDelete size={18} />
                            </Button>
                            
                            <Button className="btn btn-sm" variant="light" >

                                {this.state.open ?  <BsFillCaretUpFill size={18}/>: <BsFillCaretDownFill size={18}/> }
                                 
                            </Button>
                            
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ span: 12 }}>
                            <p style={{ color: 'grey' }}>
                                {this.props.group.description}
                            </p>
                        </Col>
                    </Row>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={this.props.orderChild ? "-1" : `${this.props.index}`}>
                    <Card.Body style={{ marginLeft: '5%', width: '90%' }}>
                        {
                            this.state.add ?
                                <Modal show={this.state.add} onHide={this.closeModal}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>{`Add ${this.state.type}`}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {
                                            this.state.type === 'section' ?

                                                <GenericForm
                                                    heading="Add Section"
                                                    title=""
                                                    description=""
                                                    saveCallBack={(data) => this.handleAddConcept('section', data)}
                                                    closeCallBack={this.closeModal}
                                                />
                                                :
                                                <AddElementForm
                                                    cancelCallback={this.closeModal}
                                                    saveCallback={this.handleAddConcept}
                                                    type={this.state.type}
                                                />
                                        }
                                    </Modal.Body>
                                </Modal>
                                :
                                <React.Fragment>
                                    <div className="d-flex flex-row justify-content-between">
                                        <DropdownButton
                                            className="shadow"
                                            drop="right"
                                            size="sm"
                                            variant="primary"
                                            title={<span><FiPlusCircle size={15} /> Add Content</span>}
                                            id={`dropdown-button-drop-right`}
                                            onSelect={this.openModal}
                                        >
                                            <Dropdown.Item eventKey="section">Section</Dropdown.Item>
                                            <Dropdown.Item eventKey="document">Document</Dropdown.Item>
                                            <Dropdown.Item eventKey="video">Video</Dropdown.Item>
                                            <Dropdown.Item eventKey="quiz">Quiz</Dropdown.Item>
                                        </DropdownButton>
                                        {/* <Button className="btn btn-sm" onClick={this.handleReorder} style={{ backgroundColor: 'white', color: 'black' }}>
                                            <span>
                                                <MdImportExport size={18} />{' '}
                                                {this.state.order ? 'Save Order' : 'Reorder'}
                                            </span>
                                        </Button> */}
                                    </div>
                                    <br />
                                    <Container style={{ minHeight: '20px', padding: '0px' }} id={`conceptListContainer-${this.props.group.id}`}>
                                        {!this.props.loaded ? null :
                                            this.props.concepts.map((concept, i) => {
                                                let type_of_concept = 'section';
                                                let bit = 0;
                                                bit += (concept.quizzes.length != 0) ? 4 : 0;
                                                bit += (concept.videos.length != 0) ? 2 : 0;
                                                bit += (concept.pages.length != 0) ? 1 : 0;
                                                console.log(bit);

                                                type_of_concept = bit == 4 ? 'quiz' : type_of_concept;
                                                type_of_concept = bit == 2 ? 'video' : type_of_concept;
                                                type_of_concept = bit == 1 ? 'page' : type_of_concept;

                                                return (
                                                    <Row key={concept.id} id={`${concept.id}`} className="border no-gutters" style={{ padding: '1%' }}>
                                                        <Col xs={{ span: 1 }}>
                                                            {this.state.order || this.props.orderChild ?
                                                                <GrDrag size={20} className={`conceptListHandle`} color="#ccc" /> : ''}
                                                        </Col>
                                                        <Col xs={{ span: 1 }}>
                                                            <FcFolder className={type_of_concept == 'section' ? '' : "d-none"} size={20} />
                                                            <FcDocument className={type_of_concept == 'page' ? '' : "d-none"} size={20} />
                                                            <FcCamcorderPro className={type_of_concept == 'video' ? '' : "d-none"} size={20} />
                                                            <FcQuestions className={type_of_concept == 'quiz' ? '' : "d-none"} size={20} />
                                                        </Col>

                                                        <Col xs={{ span: 5 }} className="align-items-center">
                                                            <Link className="text-dark align-middle" to={`/frontend/concept/${concept.id}`}>
                                                                {concept.title}
                                                            </Link>
                                                        </Col>

                                                        {/* <Col xs={{ span: 2 }}>
                                                            <label>{concept.is_published ? "UnPublish" : "Publish"}</label>
                                                            <label className="switch">
                                                                <input type="checkbox" checked={concept.is_published}
                                                                    onChange={(e) => { this.handlePublishConcept(concept) }}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </Col> */}


                                                        <Col xs={{ span: 5 }} className="justify-content-center">
                                                            {/* <Button className="btn btn-sm mx-2 shadow border-0" onClick={(e) => { this.handlePublishConcept(concept) }}
                                                                style={{ backgroundColor: concept.is_published ? "#D55959" : "darkcyan" }}
                                                            >
                                                                {concept.is_published ? "UnPublish" : "Publish"}
                                                            </Button> */}
                                                            <div className="d-flex flex-row align-items-center justify-content-end">
                                                                <span className="align-middle" style={{ fontSize: '15px' }}>Published :</span>
                                                                <label className="switch">
                                                                    <input className="switch-input" type="checkbox" onClick={(e) => { this.handlePublishConcept(concept) }}
                                                                        checked={concept.is_published} id="publishToggle" />
                                                                    <span className="switch-label" data-on="Yes" data-off="No"></span>
                                                                    <span className="switch-handle"></span>
                                                                </label>
                                                                <Button className="btn btn-sm mx-3" variant="light" onClick={(e) => { this.handleDeleteConcept(concept.id) }}>
                                                                    <MdDelete size={18} />
                                                                </Button>
                                                            </div>

                                                        </Col>
                                                    </Row>


                                                );
                                            })
                                        }
                                    </Container>
                                </React.Fragment>

                        }
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        );
    }
}


interface IReduxState {
    instructorCourseGC: ICourseGC;
}


const mapStateToProps = (state: IReduxState, { group, index, orderParent, orderChild, deleteCallBack, editCallBack }) => {
    const common = {
        group,
        index,
        orderChild,
        orderParent,
        deleteCallBack,
        editCallBack
    }
    let sGC = state.instructorCourseGC;
    if (sGC.instructorGroupConceptsMap.has(group.id)) {
        return {
            loaded: true,
            concepts: sGC.instructorGroupConceptsMap.get(group.id),
            ...common
        }
    }
    else {
        return {
            loaded: false,
            concepts: [],
            ...common
        }
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        loadGroupConceptsRequest,
        deleteGroupConceptsRequest,
        publishGroupConceptsRequest,
        reorderGroupConceptsRequest,
        addGroupConceptsRequest,
    }, dispatch)
})


export default connect(mapStateToProps, mapDispatchToProps)(Group);